import { Polygon } from 'geojson';

import { ZoneFormTypeEnum } from '@/types/config/config.types';
import { ProcedureModel } from '@/types/config/procedure.types';
import { ZoneFormDisplayedFormatEnum } from '@/types/map.types';

export type ZoneCodeAndType = {
  code: string;
  type: ZoneFormTypeEnum;
};

export enum ZoneFormGeometryTypeEnum {
  INFINITE_HEIGHT = 'INFINITE_HEIGHT',
  FINITE_HEIGHT = 'FINITE_HEIGHT',
}

export interface ZoneForm {
  id: number | undefined;
  name: string;
  type: ZoneFormTypeEnum | undefined;
  platform: string | undefined;
  geometry: ZoneFormGeometryTypeEnum;
  procedureModel: ProcedureModel | null;
  isZoneActive: boolean;
  displayedFormat: ZoneFormDisplayedFormatEnum;
  lowerValue: number | null;
  upperValue: number | null;
  marginSize: number;
  polygon: Polygon;
}
